import React, { useState, useRef, useEffect } from "react";
import "./DropDown.scss";
import { ReactComponent as Arrow } from "../../assets/images/arrowdd.svg";

function DropDown({
  invalid,
  options,
  value,
  onChange,
  label,
  placeholder = "Select",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isSelected, setIsSelected] = useState(!!value);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Update isSelected state when value changes externally
  useEffect(() => {
    setIsSelected(!!value);
  }, [value]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
    setIsSelected(true);
  };

  return (
    <div className="form-field">
      {label && <div className="dropdown-label">{label}</div>}
      <div
        ref={dropdownRef}
        className={`dropdown ${invalid ? "dropdown-invalid" : ""}`}
        onClick={handleToggle}
      >
        <div className={isSelected ? "selected-option" : "select-option"}>
          {value || placeholder}
          <span className={`arrow ${isOpen ? "open" : ""}`}>
            <Arrow />
          </span>
        </div>
        {isOpen && (
          <div className="options">
            {options && options.length > 0 ? (
              options.map((option, index) => (
                <div
                  key={index}
                  className="option"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOptionClick(option);
                  }}
                >
                  {option}
                </div>
              ))
            ) : (
              <div className="option no-options">No options available</div>
            )}
          </div>
        )}
      </div>
      {invalid && (
        <div className="form-error-message">Please select a valid option</div>
      )}
    </div>
  );
}

export default DropDown;

// // CustomDropdown.js
// import React, { useState } from "react";
// import "./DropDown.scss";

// import { ReactComponent as Arrow } from "../../assets/images/arrowdd.svg";

// function DropDown({ invalid, options, value, onChange, label }) {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isSelected, setIsSelected] = useState(false);

//   const handleToggle = () => {
//     setIsOpen(!isOpen);
//   };

//   const handleOptionClick = (value) => {
//     onChange(value);
//     setIsOpen(false);
//     setIsSelected(true);
//   };

//   return (
//     <>
//       <div className="dropdown-label">{label}</div>
//       <div
//         className={invalid ? "dropdown-invalid dropdown" : "dropdown"}
//         onClick={handleToggle}
//       >
//         <div className={isSelected ? "selected-option" : "select-option"}>
//           {value || "Select"}
//           <span className={`arrow ${isOpen ? "open" : ""}`}>
//             <Arrow />
//           </span>
//         </div>
//         {isOpen && (
//           <div className="options">
//             {options &&
//               options.map((option, index) => (
//                 <div
//                   key={index}
//                   className="option"
//                   onClick={() => handleOptionClick(option)}
//                 >
//                   {option}
//                 </div>
//               ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default DropDown;
